<template>
  <div class="fix">
    <img
      class="slide-lemon"
      style="width: 0.97rem;
      margin-bottom: -0.45rem;
      margin-left: -0.07rem;
      z-index: 9999;"
      src="../../assets/image/slide-lemon.png"
    />
    <div class="fix-menu">
      <div class="fix-menu-box">
        <div class="fix-menu-item fix-menu-item-tel cus-pointer" >
          <img
            style="width: 0.3rem;height: 0.3rem;margin-top: 0.4rem"
            src="../../assets/image/slide-mobile.png"
          />
          <span>电话咨询</span>
          <div class="tel-box-div">
            <div
            class="tel-box"
            style="font-size: 0.16rem;background: white"
          >
            <div style="margin-bottom: 0.1rem;">商务合作</div>
            <div style="font-size: 0.2rem">18665393445</div>
              <div style="margin-bottom: 0.1rem;margin-top: 0.2rem">网络问题</div>
              <div style="font-size: 0.2rem">400-666-5780</div>
          </div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="fix-menu-item fix-menu-item-wx cus-pointer">
          <img
            style="width: 0.3rem;height: 0.3rem"
            src="../../assets/image/slide-code.png"
          />
          <span>联系我们</span>
          <div class="wx-box-div">
            <div
              class="wx-box"
              style="font-size: 0.16rem;background: white"
            >
              <img v-if="imgFlag==0"  style="margin:0;width: 1.3rem" src="@/assets/image/index/wx-public.jpg">
              <img v-else style="margin:0;width: 1.3rem" :src="img">
              <div style="color: black">扫码联系我们</div>
            </div>
          </div>
        </div>
        <div class="hr"></div>
<!--        <div class="fix-menu-item cus-pointer" @click="triggerCustomerService">-->
<!--          <img-->
<!--            style="width: 0.3rem;height: 0.3rem"-->
<!--            src="../../assets/image/slide-customer.png"-->
<!--          />-->
<!--          <span>在线咨询</span>-->
<!--        </div>-->

<!--        <div class="hr"></div>-->
        <div class="fix-menu-item cus-pointer" @click="backTop()">
          <img
            style="width: 0.2356rem;height: 0.3rem"
            src="../../assets/image/slide-top.png"
          />
          <span>置顶</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slide",
  data(){
    return{
      imgFlag:0,
      img:'',
    }
  },
  mounted() {

  },
  created() {
    this.initializeAndRun();
  },
  methods: {
    triggerCustomerService() {
      if (typeof __egeelTalk === 'function') {
        __egeelTalk();
      } else {
        console.error('Customer service function is not defined');
      }
    },
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // 平滑滚动
      });
    },
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode(){
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if(data.code==200){
            this.imgFlag=1;
            this.img=data.data.qr_code;
          }
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.fix {
  position: fixed;
  //top: 50%;
  left: 0.3rem;
  bottom: 1.5rem;
  //transform: translateY(-50%); /* 通过位移修正垂直居中偏移 */
  display: flex;
  flex-direction: column;
  z-index: 999999;
}

.slide-lemon {
}

.fix-menu {
  font-weight: 400;
  font-size: 0.14rem;
  color: #3b5377;
  z-index: 999;
  border-radius: 0.04rem;
  width: 0.76rem;

  .fix-menu-box {
    background: #dbe002;
    .fix-menu-item-tel{
      .tel-box-div{
        position: absolute;
        left: 0;
        padding-left: 1rem;
        display: none;
      }
      .tel-box {
        font-size: 0.16rem;
        background: white;
        width: 2.3rem;
        text-align: center;
        border-radius: 0.05rem;
        padding: 0.1rem 0;
      }
      &:hover {
        .tel-box-div {
          display: block;
        }
        .tel-box{
          box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.1);
        }
      }
    }
    .fix-menu-item-wx {
      .wx-box-div{
        position: absolute;
        left: 0;
        padding-left: 1rem;
        display: none;
      }
      .wx-box {
        background: white;
        width: 1.7rem;
        text-align: center;
        border-radius: 0.05rem;
        margin-bottom: 0;
        margin-top: 0;
        padding: 0.2rem 0;
        bottom: 0;
      }
      &:hover {
        .wx-box-div {
          display: block;
        }
        .wx-box{
          box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.1);
        }
      }
    }
    .fix-menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      img {
        margin-bottom: 0.1rem;
        margin-top: 0.2rem;
      }

      span {
        margin-bottom: 0.2rem;
      }
    }
  }
}

.hr {
  border-bottom: 0.01rem solid #999999;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/slide/Slide.vue